const VERY_GOOD = {text: '매우좋음(+50%)', value: '0.5'};
const GOOD = {text: '좋음(+25%)', value: '0.25'};
const SOSO = {text: '보통', value: '0'};
const BAD = {text: '나쁨(-25%)', value: '-0.25'};
const VERY_BAD = {text: '매우나쁨(-50%)', value: '-0.5'};

const sizeByDmg = (weaponSize, monsterSize) => {
  let result = {text: '오류', value: '0'};
  
  switch(weaponSize) {
    case '소형': 
      if(monsterSize === '소형') result = SOSO;
      else if(monsterSize === '중형') result = BAD;
      else if(monsterSize === '대형') result = VERY_BAD;
    break;
    case '중형': 
      if(monsterSize === '소형') result = GOOD;
      else if(monsterSize === '중형') result = SOSO;
      else if(monsterSize === '대형') result = BAD;
    break;
    case '대형': 
      if(monsterSize === '소형') result = VERY_GOOD;
      else if(monsterSize === '중형') result = GOOD;
      else if(monsterSize === '대형') result = SOSO;
    break;
    default: result = {text: '오류', value: '0'};
    break;
  }
  
  return result;
}

const typeByDmg = (myType, monsterType) => {
  let result = {text: '오류', value: '0'};

  switch(myType) {
    case '일반': 
      if(monsterType === '일반') result = SOSO;
      else if(monsterType === '연성') result = SOSO;
      else if(monsterType === '강성') result = SOSO;
      else if(monsterType === '변이') result = SOSO;
      else if(monsterType === '장갑') result = BAD;
      else if(monsterType === '중장갑') result = VERY_BAD;
    break;
    case '소이': 
      if(monsterType === '일반') result = SOSO;
      else if(monsterType === '연성') result = GOOD;
      else if(monsterType === '강성') result = BAD;
      else if(monsterType === '변이') result = SOSO;
      else if(monsterType === '장갑') result = BAD;
      else if(monsterType === '중장갑') result = VERY_BAD;
    break;
    case 'Slug': 
      if(monsterType === '일반') result = GOOD;
      else if(monsterType === '연성') result = SOSO;
      else if(monsterType === '강성') result = SOSO;
      else if(monsterType === '변이') result = BAD;
      else if(monsterType === '장갑') result = BAD;
      else if(monsterType === '중장갑') result = VERY_BAD;
    break;
    case '철갑': 
      if(monsterType === '일반') result = BAD;
      else if(monsterType === '연성') result = BAD;
      else if(monsterType === '강성') result = GOOD;
      else if(monsterType === '변이') result = BAD;
      else if(monsterType === '장갑') result = SOSO;
      else if(monsterType === '중장갑') result = SOSO;
    break;
    case '열화': 
      if(monsterType === '일반') result = BAD;
      else if(monsterType === '연성') result = SOSO;
      else if(monsterType === '강성') result = SOSO;
      else if(monsterType === '변이') result = GOOD;
      else if(monsterType === '장갑') result = BAD;
      else if(monsterType === '중장갑') result = VERY_BAD;
    break;
    case '유탄': 
      if(monsterType === '일반') result = GOOD;
      else if(monsterType === '연성') result = GOOD;
      else if(monsterType === '강성') result = BAD;
      else if(monsterType === '변이') result = BAD;
      else if(monsterType === '장갑') result = VERY_BAD;
      else if(monsterType === '중장갑') result = VERY_BAD;
    break;
    case '대인로켓': 
      if(monsterType === '일반') result = VERY_GOOD;
      else if(monsterType === '연성') result = VERY_GOOD;
      else if(monsterType === '강성') result = BAD;
      else if(monsterType === '변이') result = BAD;
      else if(monsterType === '장갑') result = VERY_BAD;
      else if(monsterType === '중장갑') result = VERY_BAD;
    break;
    case '대전차탄': 
      if(monsterType === '일반') result = BAD;
      else if(monsterType === '연성') result = BAD;
      else if(monsterType === '강성') result = BAD;
      else if(monsterType === '변이') result = GOOD;
      else if(monsterType === '장갑') result = GOOD;
      else if(monsterType === '중장갑') result = SOSO;
    break;
    case '대전차로켓': 
      if(monsterType === '일반') result = BAD;
      else if(monsterType === '연성') result = BAD;
      else if(monsterType === '강성') result = GOOD;
      else if(monsterType === '변이') result = GOOD;
      else if(monsterType === '장갑') result = VERY_GOOD;
      else if(monsterType === '중장갑') result = GOOD;
    break;
    case '중금속': 
      if(monsterType === '일반') result = GOOD;
      else if(monsterType === '연성') result = BAD;
      else if(monsterType === '강성') result = GOOD;
      else if(monsterType === '변이') result = SOSO;
      else if(monsterType === '장갑') result = BAD;
      else if(monsterType === '중장갑') result = BAD;
    break;
    case '전속성': 
      if(monsterType === '일반') result = GOOD;
      else if(monsterType === '연성') result = GOOD;
      else if(monsterType === '강성') result = GOOD;
      else if(monsterType === '변이') result = GOOD;
      else if(monsterType === '장갑') result = GOOD;
      else if(monsterType === '중장갑') result = GOOD;
    break;
    default: result = {text: '오류', value: '0'};
    break;
  }

  return result;
}

export const weaponSkillList = [
  {seq:'0', weaponType:'', name:'', img:'', increaseTarget:'', increaseRt:'0', costVigor:'0', },
  {seq:'1', weaponType:'도검', name:'치명타격', img:'/resource/img/skill_ico001.gif', increaseTarget:'cri', increaseRt:'2', costVigor:'25', },
  {seq:'2', weaponType:'도검', name:'전력타격', img:'/resource/img/skill_ico002.gif', increaseTarget:'all', increaseRt:'1.5', costVigor:'35', },
  {seq:'3', weaponType:'둔기', name:'전력타격', img:'/resource/img/skill_ico003.gif', increaseTarget:'all', increaseRt:'4', costVigor:'250', },
  {seq:'4', weaponType:'도끼', name:'전력타격', img:'/resource/img/skill_ico004.gif', increaseTarget:'all', increaseRt:'2', costVigor:'75', },
  {seq:'5', weaponType:'장창', name:'전력투척', img:'/resource/img/skill_ico005.gif', increaseTarget:'all', increaseRt:'2', costVigor:'60', },
  {seq:'6', weaponType:'돌격소총', name:'치명연사', img:'/resource/img/skill_ico006.gif', increaseTarget:'cri', increaseRt:'2', costVigor:'25', },
  {seq:'7', weaponType:'돌격소총', name:'급소연사', img:'/resource/img/skill_ico007.gif', increaseTarget:'all', increaseRt:'1.5', costVigor:'40', },
  {seq:'8', weaponType:'기관총', name:'치명연사', img:'/resource/img/skill_ico008.gif', increaseTarget:'cri', increaseRt:'2', costVigor:'30', },
  {seq:'9', weaponType:'기관총', name:'급소연사', img:'/resource/img/skill_ico009.gif', increaseTarget:'all', increaseRt:'1.5', costVigor:'50', },
  {seq:'10', weaponType:'저격소총', name:'원거리추뎀', img:'/resource/img/skill_ico009.gif', increaseTarget:'all', increaseRt:'1.5', costVigor:'0', },
  {seq:'11', weaponType:'샷건', name:'벽부딪힘', img:'/resource/img/skill_ico009.gif', increaseTarget:'all', increaseRt:'1.5', costVigor:'0', },
  {seq:'12', weaponType:'샷건', name:'근접사격', img:'/resource/img/skill_ico009.gif', increaseTarget:'all', increaseRt:'3', costVigor:'0', },
  {seq:'13', weaponType:'샷건', name:'벽부딪힘+근접사격', img:'/resource/img/skill_ico009.gif', increaseTarget:'all', increaseRt:'4.5', costVigor:'0', },
  {seq:'14', weaponType:'기관총', name:'치명연사+벽부딪힘', img:'/resource/img/skill_ico009.gif', increaseTarget:'cri', increaseRt:'2', costVigor:'50', },
  {seq:'15', weaponType:'기관총', name:'급소연사+벽부딪힘', img:'/resource/img/skill_ico009.gif', increaseTarget:'all', increaseRt:'2.25', costVigor:'50'}
];

export function calcDamage({ myStat, currSelWeapon }) {
  
  const {con, ski, itemDmg, itemCri, achDmg, rimtDmg, isPara, isDoping, weaponType, monSize, monType, selSkillSeq} = myStat;

  const checkedParaY = isPara === 'Y' ? true : false;
  // const checkedParaN = isPara === 'N' ? true : false;
  const checkedDopingY = isDoping === 'Y' ? true : false;
  // const checkedDopingN = isDoping === 'N' ? true : false;
  const {currItem, currItemPoweredBy, currItemOption} = currSelWeapon;
  const {bodyUp, powerUp} = currItemOption;
  const {CRI, STYPE1, SIZE} = currItem;

  //인벤공계산
  const mainStat = STYPE1 === '1' ? ski : con;
  const currWeaponDmgCalc = currItemPoweredBy.length === 0 ? 0 : currItemPoweredBy[bodyUp][powerUp];
  const parasiteUp = checkedParaY ? 3 : 0;
  const dopingUp = checkedDopingY ? 2 : 0;
  const default_inven_dmg = Math.floor(Number(currWeaponDmgCalc)+Number(currWeaponDmgCalc)*(Number(mainStat)/100)+Number(mainStat));
  const item_inven_dmg = (default_inven_dmg/100)*Number(itemDmg);
  const inven_dmg = Math.floor((default_inven_dmg + item_inven_dmg)*(1+(Number(rimtDmg)/100))*(1+(Number(achDmg)/100))*(1+parasiteUp/10)*(1+Number(dopingUp)/10));
  //인벤공계산 끝
  //크리헤샷비율계산
  const upCri = CRI !== undefined ? String(Math.floor(CRI*1.5)) : '0'; //전문업 크리
  let inven_cri = Math.floor(((Number(upCri)/5) * ((Number(ski)/100)+1)) + Number(itemCri) + 1);
  inven_cri = inven_cri > 50 ? 50 : inven_cri;
  const head_atk_rt = (3+(ski/50)).toFixed(2);
  //크리헤샷비율계산 끝

  const sizeDmg = sizeByDmg(SIZE, monSize);
  const typeDmg = typeByDmg(weaponType, monType);
  const currSkill = weaponSkillList.filter(skill => skill.seq === selSkillSeq)[0];
  const {increaseTarget, increaseRt, seq} = currSkill;

  let defaultDmg1 = (typeDmg.text === '오류' || sizeDmg.text === '오류') ? '0' : 
  inven_dmg + (inven_dmg * Number(sizeDmg.value));
  let defaultDmg = (typeDmg.text === '오류' || sizeDmg.text === '오류') ? '0' : 
  defaultDmg1 + (defaultDmg1 * Number(typeDmg.value));

  defaultDmg = defaultDmg * 1.1; //사공+이벤공증+정규
  defaultDmg = defaultDmg * (increaseTarget === 'all' ? Number(increaseRt) : 1);
  defaultDmg = defaultDmg * (seq === '14' ? 1.5 : 1); // 기관총 치명연사+벽부딪힘

  const totalDmg = {
    normalDmg: {
      name: 'normalDmg',
      min: Math.ceil(defaultDmg * 0.8),
      max: Math.ceil(defaultDmg * 1.2)
    },
    normalDmgFire: {
      name: 'normalDmgFire',
      min: Math.ceil(defaultDmg * 1.5 * 0.8),
      max: Math.ceil(defaultDmg * 1.5 * 1.2)
    },
    criDmg: {
      name: 'criDmg',
      min: Math.ceil(defaultDmg * (head_atk_rt/2 * (increaseTarget === 'cri' ? Number(increaseRt) : 1)) * 0.8),
      max: Math.ceil(defaultDmg * (head_atk_rt/2 * (increaseTarget === 'cri' ? Number(increaseRt) : 1)) * 1.2)
    },
    criDmgFire: {
      name: 'criDmgFire',
      min: Math.ceil(defaultDmg * (head_atk_rt/2 * (increaseTarget === 'cri' ? Number(increaseRt) : 1)) * 1.5 * 0.8),
      max: Math.ceil(defaultDmg * (head_atk_rt/2 * (increaseTarget === 'cri' ? Number(increaseRt) : 1)) * 1.5 * 1.2)
    },
    headDmg: {
      name: 'headDmg',
      min: Math.ceil(defaultDmg * (head_atk_rt * (increaseTarget === 'cri' ? Number(increaseRt) : 1)) * 0.8),
      max: Math.ceil(defaultDmg * (head_atk_rt * (increaseTarget === 'cri' ? Number(increaseRt) : 1)) * 1.2)
    },
    headDmgFire: {
      name: 'headDmgFire',
      min: Math.ceil(defaultDmg * (head_atk_rt * (increaseTarget === 'cri' ? Number(increaseRt) : 1)) * 1.5 * 0.8),
      max: Math.ceil(defaultDmg * (head_atk_rt * (increaseTarget === 'cri' ? Number(increaseRt) : 1)) * 1.5 * 1.2)
    }
  }

  return {
    weaponSkillList,
    inven_cri,
    head_atk_rt,
    inven_dmg,
    totalDmg
  };
}

export const bodyUpList = [
  {name: '기본', value: 0},
  {name: '초보', value: 1},
  {name: '숙련', value: 2},
  {name: '전문', value: 3},
  {name: '장인', value: 4},
  {name: '명인', value: 5},
  {name: 'O.T', value: 6}
];

export const powerUpList = [
  {name: '노강', titleName:'', titleClName: '[CL]'},
  {name: '1강', titleName:'+1', titleClName: '[CL]+1'},
  {name: '2강', titleName:'+2', titleClName: '[CL]+2'},
  {name: '3강', titleName:'+3', titleClName: '[CL]+3'},
  {name: '4강', titleName:'+4', titleClName: '[CL]+4'},
  {name: '5강', titleName:'+5', titleClName: '[CL]+5'},
  {name: '6강', titleName:'+6', titleClName: '[CL]+6'},
  {name: '7강', titleName:'+7', titleClName: '[CL]+7'},
  {name: '8강', titleName:'+8', titleClName: '[CL]+8'},
  {name: '9강', titleName:'+9', titleClName: '[CL]+9'},
  {name: '맥강', titleName:'MAX', titleClName: '[CL-MAX]'},
  {name: '맥1강', titleName:'MAX+1', titleClName: '[CL-MAX]+1'},
  {name: '맥2강', titleName:'MAX+2', titleClName: '[CL-MAX]+2'},
  {name: '맥3강', titleName:'MAX+3', titleClName: '[CL-MAX]+3'},
  {name: '맥4강', titleName:'MAX+4', titleClName: '[CL-MAX]+4'},
  {name: '맥5강', titleName:'MAX+5', titleClName: '[CL-MAX]+5'},
  {name: '맥6강', titleName:'MAX+6', titleClName: '[CL-MAX]+6'},
  {name: '맥7강', titleName:'MAX+7', titleClName: '[CL-MAX]+7'},
  {name: '맥8강', titleName:'MAX+8', titleClName: '[CL-MAX]+8'},
  {name: '맥9강', titleName:'MAX+9', titleClName: '[CL-MAX]+9'}
];